<template>
    <div class="sfAIFastFoodDetail">
        <div class="sfAIFastFood-pay" v-show="isShow" v-readCard="5" @barcode="payCode" @keydown.stop @click="$refs.tab?.focus()">
            <div ref="tab" tabindex="-1" ></div>
            <div class="sf-left-box">
                <header-box ref="headerBox" @checkUser="isCheckUserShow=true" />
                <div class="sf-screen-box" ref="screenBox">
                    <sf-screen ref="sfScreen" class="screen-bg" v-if="userInfo?.Is_Reg_AISelfPos && $global.SFAiStatus"/>
                    <div class="payTip weiZhi" v-if="isWeiZhiFoot">有未识别的菜品，请联系服务员！</div>
                    <div class="payTip" v-else-if="total.number>0">请出示微信/支付宝二维码支付</div>
                    <!-- <div class="plate-box">
                        <div class="plate-li" v-for="(plate,index) in plateList" :key="plate">
                            <div class="bnt-close" @click="delPlate(index)"><i class="iconfont icon-a-bg-close3x"></i></div>
                            <div class="plate-name">餐盘{{index+1}}</div>
                            <div class="food-list">
                                <div class="food-li" v-for="item in plate" :key="item">
                                    <div class="name">·{{item.EAT_XFName}}</div>
                                    <div class="price">￥{{item.Eat_CheckPrice}} </div>
                                    <div class="num">x{{item.Eat_Number}}</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="food-bnt">
                        <!-- <div class="set-bnt" @click="setClick"><i class="iconfont icon-zizhuxuexi"></i>学习</div> -->
                        <div class="reIdentify-bnt" @click="reIdentify"><i class="iconfont icon-zhongxin"></i>重新识别</div>
                        <div class="flex1"></div>
                        <!-- <div class="tag-bnt">
                            <div class="bnt" @click="addCard"><i class="iconfont icon-diejia"></i>叠加识别</div>
                            <div class="bnt" @click="reIdentify"><i class="iconfont icon-zhongxin"></i>重新识别</div>
                        </div> -->
                        <div class="add-bnt" @click="isShow=false"><i class="iconfont icon-jia"></i></div>
                    </div>
                    <div class="diy-add-food">
                        <div class="food-li" v-for="(item,index) in freeList" :key="item" @click="delFree(index)">
                            <div class="flex-box">
                                <div class="name">{{item.EAT_XFName}}</div>
                                <div class="price">￥{{item.Eat_CheckPrice}}</div>
                                <div class="num">x{{item.Eat_Number}}</div>
                                <i class="iconfont icon-a-bg-close3x"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="sf-right-box">
                <div class="right-title">
                    <div class="text">已识别菜品（共0个餐盘）</div>
                    <div class="addCard-bnt" @click="addCard"><i class="iconfont icon-diejia"></i>叠加识别</div>
                    <div class="page-bnt">
                        <div class="bnt" ref="order-up"><i class="iconfont icon-shang"></i></div>
                        <div class="bnt" ref="order-down"><i class="iconfont icon-xia"></i></div>
                    </div>
                </div>
                <div class="cart-box">
                    <div class="empty-name" v-if="total.number==0">请放入托盘</div>
                    <div class="cart-scroll-box" v-else v-scroll-anime="{up:'order-up',down:'order-down',liClass:'.item-box'}">
                        <div class="item-box" v-for="(plate,index) in plateList" :key="plate">
                            <div class="plate-li">
                                <div class="plate-name tr">
                                    <div class="name">餐盘{{index+1}}（共{{plate.length}}个菜）</div>
                                    <div class="bnt-close" @click="delPlate(index)"><i class="iconfont icon-shanchu1"></i></div>
                                </div>
                                <div class="food-list">
                                    <div class="food-li tr" v-for="item in plate" :key="item">
                                        <div class="name">·{{item.EAT_XFName}}</div>
                                        <div class="price">￥{{item.Eat_CheckPrice}} </div>
                                        <div class="num">x{{item.Eat_Number}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="member-box">
                    <div class="empty-member" v-if="!memberInfo">
                        <div class="text">扫会员码登录</div>
                        <i class="iconfont icon-arrow-right"></i>
                    </div>
                    <div class="member-flex" v-else>
                        <div class="flex1">
                            <div class="phone">159****8888</div>
                            <div class="tr">
                                卡内余额：<span class="money"><span class="unit">￥</span>389.89</span>
                            </div>
                        </div>
                        <div class="more-bnt">
                            <span class="text">已选择5元优惠券</span>
                            <i class="iconfont icon-arrow-right"></i>
                        </div>
                    </div>
                </div>
                <div class="total-box">
                    <div class="discount-money">
                        优惠金额：￥{{total.discountMoneuy}}
                    </div>
                    <div class="total-money">
                        <span class="num">共{{total.number}}件</span> 总计：
                        <div class="flex1 money"><span class="unit">￥</span>{{total.unPaidMoney}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex-column-box" v-show="!isShow">
            <header-box />
            <select-food-list />
        </div>
        <div class="pop-status" v-show="payStatus==-1 || payStatus==0">
            <div class="error" v-show="payStatus==-1">
                
                <i class="iconfont icon-a-bg-close3x"></i>
                <div class="name">支付失败!</div>
                <div class="tip-text">请重新支付</div>
            </div>
            <div class="success" v-show="payStatus==0">
                <i class="iconfont icon-danxuan_fuxuan"></i>
                <div class="name">支付成功!</div>
            </div>
        </div>
        
        
        <modal-load :isShow="isScanPayShow">
            <scan-pay-modal :payCode="scanPayCode" :isShow="isScanPayShow" @close="isScanPayShow=false" @success="init()"/>
        </modal-load>
        <!-- 温馨提示 -->
        <modal-load :isShow="isTipShow">
            <tip-modal :isShow="isTipShow" :data="tipData" @close="isTipShow=false"/>
        </modal-load>
        <!-- 用户验证 -->
        <modal-load :isShow="isCheckUserShow">
            <check-user-modal :isShow="isCheckUserShow" @close="isCheckUserShow=false" @success="backHome()"/>
        </modal-load>
    </div>
</template>

<script>
//食方ai 快餐点餐支付
import {newGuid} from '../../../common/index'
import headerBox from './headerBox/headerBox.vue'
import selectFoodList from './selectFoodList/selectFoodList.vue'
import scanPayModal from './scanPayModal/scanPayModal.vue'
import tipModal from './tipModal/tipModal.vue'
import checkUserModal from './checkUserModal/checkUserModal.vue'
export default {
    components:{
        scanPayModal,
        selectFoodList,
        headerBox,
        tipModal,
        checkUserModal
    },
    data(){
        return {
            userInfo:null,
            timeTxt:'',
            isShow:true,
            //付款状态
            payStatus:null,
            //菜品数据 
            posFoodData:null,
            //餐盘
            plateList:[],
            //自选
            freeList:[],
            //所有支付方式
            PayTypes:[],
            //渠道 支付时需要
            Default_ChannelID:null,
            //餐厅 支付时需要
            Default_RoomID:null,
            //重新处理是需要
            EatAutoID:null,
            //订单单时间戳，当异常单重新处理时需要传入
            Timestamps:null,
            //扫码付款
            isScanPayShow:false,
            //扫码付款 付款码
            scanPayCode:"",
            //会员信息
            memberInfo:null,
            //添加菜品 报错信息
            addItemError:"",
            //温馨提示 弹层
            isTipShow:false,
            tipData:null,
            //用户验证 弹层
            isCheckUserShow:false,
            oldFoodIDS:[]
        }
    },
    computed:{
        //弹层是否显示
        modalShow(){
            return this.isScanPayShow || this.isTipShow || this.isCheckUserShow;
        },
        //扫码付款方式  壹钱包支付->聚合支付->提示未配置扫码付款
        payTypeSSPay(){
            let payType=this.PayTypes.find(it=>it.INTERFACE_TYPE=="9056001");//壹钱包支付
            if(!payType){
                payType=this.PayTypes.find(it=>it.INTERFACE_TYPE=="801010301");//聚合支付
            }
            return payType;
        },
        //所有菜品  排除套餐菜
        foodAll(){
            let all=[];
            this.getPosFoodData?.forEach(category=>{
                category?.FoodSubCategorys?.forEach(sub=>{
                    sub?.PosFoods?.forEach(it=>{
                        if(!it.Is_SetMeal){//单菜
                            all.push(it);
                            
                            it.MultipleSizeFoods?.forEach(multip=>{//多单位
                                all.push(multip);
                            })
                        }
                    })
                })
            })
            return all;
        },
        //菜品源数据
        getPosFoodData(){
            return this.posFoodData?.data||[];
        },
        //订单所有菜品
        orderList(){
            let foodlist=[];
            this.plateList?.forEach(list=>{
                list.forEach(it=>{
                    foodlist.push(it);
                })
            });
            this.freeList?.forEach(it=>{
                foodlist.push(it);
            });
            return foodlist;
        },
        /**合计 */
        total(){
            let total={
                totalMoney:0.00,//结账总金额
                unPaidMoney:0,//应收金额
                MantissaMoney:0,//位数调整金额
                number:0,
                sumMoney:0,//消费金额
                discountMoneuy:0//优惠金额
            };
            this.orderList?.forEach(it=>{
                total.number=Number(total.number).compute(it.Eat_Number);
                total.totalMoney=Number(total.totalMoney).compute((it.Eat_Number*it.Eat_CheckPrice).toFixed(2));
                //原金额
                total.sumMoney=Number(total.sumMoney).compute((it.Eat_SalePrice * it.Eat_Number).toFixed(2));
            });

            total.totalMoney=Number(total.totalMoney.toFixed(2));
            total.number=Number(total.number.toFixed(4));
            total.sumMoney=Number(total.sumMoney.toFixed(2));
            
            //计算尾数调整后的 应收金额
            total.unPaidMoney=this.$global.mantissaAdjust(this.$global.globalSysSetting?.FastFoodMantissaAdjustKind,total.totalMoney);
            //尾数调整金额(负数) 应收 - 合计金额
            total.MantissaMoney=Number((total.unPaidMoney-total.totalMoney).toFixed(2));
            //优惠金额 成本金额 - 销售金额 - 尾数调整金额
            total.discountMoneuy= Number(total.sumMoney).compute(-total.totalMoney,-total.MantissaMoney);
            return total;
        },
        /**是否有未知的菜品 */
        isWeiZhiFoot(){
            return this.oldFoodIDS?.some(it=>!it.code && it.name=="未知");
        },
    },
    watch:{
        isShow(newVal){
            if(newVal && this.$refs.tab){
                this.$nextTick(()=>{
                    this.$refs.tab?.focus();
                    this.SFAddCard();
                });
            }
        },
        modalShow(newVal){
            if(!newVal && this.$refs.tab){
                if(this._modalTime){
                    clearTimeout(this._modalTime);
                }
                this._modalTime=setTimeout(()=>{
                    this.$refs.tab?.focus();
                },100);
            }

            if(newVal){//有弹层 不去识别变动菜品
                this.clearAddCard();
            }else{
                this.SFAddCard();
            }
        }
    },
    mounted(){
        this.$emit("navIndex",0);
        this.userInfo=this.$auth.getUserInfo();
       // 仅在渲染整个视图之后运行的代码
        this.isUnmout=false;
        this.timeShow();
        
        if(this.$refs.tab){
            this.$refs.tab.focus();
        }
        //默认渠道
        this.Default_ChannelID = this.userInfo?.Default_ChannelID;
        if(!this.Default_ChannelID){
            this.$cacheData.OrderChannel().then((d)=>{
                if(d?.length>0 && d[0].OrderChannelList?.length>0){//默认第一个渠道
                    this.Default_ChannelID=d[0].OrderChannelList[0].OrderChannel_AutoID;
                }
            }).catch(()=>{
                this.$alert('暂无订单渠道', "提示", {confirmButtonText: "确定"});
            })
        }
        this.$cacheData.EatRooms().then((d)=>{
            if(d?.length>0){
                this.Default_RoomID = d[0].Room_AutoID;//默认第一个餐厅id
            }
        }).catch(e=>{
            console.log('e:'+e)
            this.$alert('未找到桌台数据', "提示", {confirmButtonText: "确定"});
        })

        //菜品数据结构
        this.$cacheData.PosFoods().then((d)=>{
           this.posFoodData=d;
        }).catch(e=>{
            console.log('e:'+e)
            this.$alert('未找到菜品数据', "提示", {confirmButtonText: "确定"});
        })

        /* 获取支付方式 */
        this.$cacheData.PayType().then((data)=>{
            data.forEach(item=>{
                item.PayTypes.forEach(pay=>{
                    this.PayTypes.push(pay);
                })
            })
        }).catch(e=>{
            this.$alert("支付方式获取失败："+e.message, "提示", {confirmButtonText: "确定"});
        })
        if(this.userInfo?.Is_Reg_AISelfPos){//该设备是否注册了AI识别点餐功能
            //监听 食方ai识别结果
            this.$webBrowser.on("openSFAi",(data)=>{
                console.log("openSFAi",data);
                if(data && (data.status==0 || data.state==0)){
                    if(data.data && !this.modalShow){
                        let itemList=data.data;
                        if(typeof(data.data)=="string"){
                            try {
                                itemList=JSON.parse(data.data);
                            } catch (error) {
                                console.log("openSFAi 解析data报错",error);
                                return ;
                            }
                        }
                        if(itemList?.length>0){
                            if(!this.oldFoodIDS || this.oldFoodIDS.length!=itemList.length || this.oldFoodIDS.some(it=>!itemList.some(food=>food.code==it.code))){//上一次识别结果与当前不同时
                                this.oldFoodIDS=itemList;
                                this.SFAIAddFood(itemList.filter(it=>it.code && it.name!="未知"));
                            }
                        }else{//没有识别到菜品，清空当前餐盘数据
                            this.oldFoodIDS=[];
                            this.plateList[this.plateList.length-1]=[];
                        }
                    }
                }
            });
            this.SFAddCard();
        }
    },
    methods:{
        init(){
            this.memberInfo=null;
            this.plateList=[];
            this.freeList=[];
            this.EatAutoID=null;
            this.Timestamps=null;
            this.isScanPayShow=false;
            this.scanPayCode="";
            this.oldFoodIDS=[];
            this.addItemError="";
            //温馨提示 弹层
            this.isTipShow=false;
            this.tipData=null;
        },
        //返回主界面
        backHome(){
            this.isCheckUserShow=false;
            this.$nextTick(()=>{
                this.$refs.headerBox && this.$refs.headerBox.backHome();
            });
        },
        timeShow(){
			//用来显示时间的方法
			if(this._time){
                clearTimeout(this._time);
            }
			let date = new Date();
			let month = "00" + (date.getMonth() + 1);
			let day = "00" + date.getDate();
			let hours = "00" +date.getHours();//小时 
			let minutes = "00" + date.getMinutes(); //分 
			let seconds = date.getSeconds();//秒
			let days = date.getDay();//星期
			let week = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
			
			this.timeTxt = month.substring(month.length - 2) + "月" + day.substring(day.length - 2) + "日 " + week[days] + " "
				+ hours.substring(hours.length - 2) + ":" + minutes.substring(minutes.length - 2);
			this._time=setTimeout(()=>{
                this.timeShow();
            }, (60 - seconds) * 1000);
		},
        //扫码
        payCode(e){
            if(!this.isShow || this.modalShow){
                return;
            }
            console.log("付款扫码",e);
            const payCode =  e.detail.trim(); // 提取中间部分并去除前缀
            if (payCode >= 16) {
                
                //微信 开头数字范围为 10-15  18位纯数字   支付宝 开头数字范围为 25-30  16-24位纯数字  壹钱包 开头数字范围为 68-69  16-30位纯数字 或 18-30位纯数字 都是付款码
                if (payCode && ((/^1[0-5]\d{16}$/.test(payCode) || /^((2[5-9])|(30))\d{14,22}$/.test(payCode)) || /^(6[8-9])\d{14,30}$/.test(payCode) || /^\d{18,30}$/.test(payCode))) {//扫码支付
                    //alert("付款扫码:"+payCode)
                    if(this.checkFood("付款")){
                        return;
                    }
                    this.payment(payCode);
                } 
            }else{
                alert("会员码:"+ payCode);
            }
        },
        //删除指定餐盘
        delPlate(index){
            if(index>=0){
                if(this.plateList.length-1==index){
                    this.oldFoodIDS=[];
                }

                this.plateList.splice(index,1);
            }
        },
        //自选
        delFree(index){
            if(index>=0){
                this.freeList.splice(index,1);
            }
        },
        /**食方ai 识别结果查询 */
        SFAddCard(){
            if(this.isShow){
                if(this._sfTime) clearTimeout(this._sfTime);
                this._sfTime=setTimeout(()=>{
                    this.$nextTick(()=>{
                        if(this.$refs.sfScreen && !this.modalShow){
                            this.$refs.sfScreen.addCard();
                        }
                    });
                    this.SFAddCard();
                },3000);
            }
        },
        clearAddCard(){
            if(this._sfTime) clearTimeout(this._sfTime);
        },
        /**判断是否有 未知 或失败的菜 */
        checkFood(title){
            const weiZhi=this.oldFoodIDS?.filter(it=>!it.code && it.name=="未知");
            if(weiZhi?.length>0 || this.addItemError){
                const errMes=[];
                if(weiZhi?.length>0){
                    errMes.push(`有未识别菜品，禁止${title}，请重新放置菜品！`);
                }
                if(this.addItemError){
                    errMes.push(this.addItemError);
                }

                this.tipData={
                    title:"无法"+title,
                    text:"注意："+errMes.join('\n')
                }
                this.isTipShow=true;
                
                //语音提示
                this.$global.dingDong(true); 
                this.$webBrowser.tts(`有未识别菜品，禁止${title}！`);
                return true;   
            }
        },
        /**食方ai点菜添加到数组中 */
        SFAIAddFood(list){
            const foodName=[],foodList=[];
            list.forEach(food=>{
                const pos=this.foodAll?.find(it=>food.code==it.Food_Code);
                if(pos){
                    foodList.push(pos);
                }else{
                    foodName.push(food.name);
                }
            })
            let error="";
            if(foodName.length>0){
                error= 'POS菜品库没有如下菜品：【'+foodName.join("、")+'】，请上架菜品！';
            }
            this.addItemError=error;
            if(error){
                this.clearAddCard();
                this.$alert(error,  "提示", {
                    type:'warning',
                    confirmButtonText: "确定"
                }).then(()=>{
                    this.SFAddCard();
                }).catch(()=>{
                    this.SFAddCard();
                })
            }

            const plateFoodList=[];
            foodList.forEach(it=>{
                let food=plateFoodList.find(food=>food.EAT_XFBMID==it.Food_ID);
                if(food){
                    food.Eat_Number++;
                }else{
                    let info=this.getFoodInfo(it);
                    plateFoodList.push(info);
                }
            });
            if(this.plateList.length==0){
                this.plateList.push(plateFoodList);
            }else{
                this.plateList[this.plateList.length-1]=plateFoodList;
            }
        },
        //返回菜品数据格式
        getFoodInfo(pos){
            //添加到订单
            let _item ={
                Eat_ConsumeID:newGuid(),
                Food_Type:1,
                SubCategory_ID:pos.SubCategory_ID,
                EAT_XFBMID:pos.Food_ID,
                EAT_XFCode:pos.Food_Code,
                EAT_XFName:pos.Food_Name,
                Eat_Number:1,
                Eat_CheckPrice:pos.Food_Price,
                ModiPrice:0,
                Eat_SalePrice:pos.Food_Price,
                Eat_VipPrice:pos.Food_VipPrice,
                Food_CostPrice:pos.Food_CostPrice,//成本金额
                Eat_MasName:'',
                Food_Status:-1,
                Food_AssSize:pos.Food_AssSize,
                AssSizeNumber:'',
                Eat_XFSize:pos.Food_Size,
                FoodModifys:null,
                FoodSetmeals:null,
                Is_Special:pos.Is_Special,//是否是特色菜
                Is_Discounted:pos.Is_Discounted,
                Is_Seasonal:pos.Is_Seasonal,
                RemainNum:pos.RemainNum,
                Is_Limited:pos.Is_Limited,
                Is_ChangedNum:pos.Is_ChangedNum,
                Is_ChargeForService:pos.Is_ChargeForService,
                OnlySupportIntNum:pos.OnlySupportIntNum,//是否数量取整
                Is_SetMeal:pos.Is_SetMeal,
                Promotion_Price:0,
                Exchanged_Number:0,
                ConsumeOperations:[]
            };
            //促销价
            if(pos?.Is_Promotion && pos?.Promotion_Price>=0){
                _item.Eat_CheckPrice = pos?.Promotion_Price
                _item.Promotion_Price = pos?.Promotion_Price
                _item.ConsumeOperations=[{OperateType:5}]
            }
            //有辅助单位
            if(pos.Food_AssSize){
                _item.AssSizeNumber=1
            }
           return _item;
        },
        //打开设置界面
        settingClick(){
            //this.$message.warning("打开设置界面");
            if(this.$refs.sfScreen)
            this.$refs.sfScreen.settingClick();
        },
        //打开菜品设置
        setClick(){
            //this.$message.warning("打开菜品设置");
            if(this.$refs.sfScreen)
            this.$refs.sfScreen.setClick();
        },
        //重新识别
        reIdentify(){
            //this.$message.warning("重新识别");
            if(this.$refs.sfScreen)
            this.$refs.sfScreen.reIdentify();
        },
        //叠加识别
        addCard(){
            
            if(this.checkFood("叠加")){
                return;
            }
            if(this.plateList[this.plateList.length-1]?.length>0){
                this.plateList.push([]);
                this.oldFoodIDS=[];
            }
            
            // if(this.payStatus==0){
            //     this.setStatus(-1);
            // }else if(this.payStatus==-1){
            //     this.setStatus(0);
            // }else{
            //     this.setStatus(-1); 
            // }
            //this.$message.warning("调用加购");
            //this.$refs.sfScreen.addCard();
        },
        //状态
        setStatus(type){
            if(this._statusTime){
                clearTimeout(this._statusTime);
            }
            if(type==-1 || type==0){
                this.payStatus=type;
                this._statusTime=setTimeout(()=>{
                    this.payStatus=null;
                },3000)
            }else{
                this.payStatus=null;
            }
        },
         //扫码付款
        payment(payCode){
            if(!(this.orderList.length>0)){
                this.$message.error('请先去选菜!');
                return;
            }
            if(!this.payTypeSSPay){
                this.$message.error('未配置扫码支付!');
                return;
            }
            if(!payCode){
                this.$message.error('付款码不能为空!');
                return;
            }
            this.scanPayCode=payCode;
            this.isScanPayShow=true;
        },
        //支付预览
        payPreview(data){
            let _orderConsumes=this.$global.getFastOrderConsumes(this.orderList);
            const userInfo=this.$auth.getUserInfo(); //获取用户id
            let param={
                User_ID:userInfo?.User_ID,  //用户id
                Eat_AutoID:this.EatAutoID, //订单ID，当异常单重新处理时需要传入
                Timestamps:this.Timestamps,//订单单时间戳，当异常单重新处理时需要传入
                Operator_Name:userInfo?.Login_Name, //操作员
                Eat_PersonNum:1,//人数
                Channel_ID:this.Default_ChannelID,//订单渠道ID
                Room_ID:this.Default_RoomID,//餐厅ID
                Eat_DeskID:'', //桌台ID
                Eat_DeskName:'', //桌台名称
                Eat_TakeNo:"",//牌号
                Eat_AllRemark:'', //订单全单备注
                Order_Remark:'',//订单备注
                Order_BatchNo:newGuid(),//下单批次号，每次提交下单，调用方生成一个唯一批次号，接口判断防止重复下单
                NotSendToKitPrint:false, //下单不送打厨房
                //ElectronicInvoice_PrintForbidden:this.$global.isNoPrintInvoice,//是否选择禁止打印发票二维码 false: 默认打印发票二维码,true: 不打印发票二维码
                MantissaAdjustment_Money: Number(Number(this.total.MantissaMoney).toFixed(2)),//尾数调整金额
                Member:null,//会员信息
                OrderConsumes:_orderConsumes, //订单消费详细
                Payments:[]
            }

            Object.assign(param,data);
            
            let timeout=8*1000//设置8秒钟 超时时间
            //银联商务聚合支付  壹钱包支付
            if(this.payTypeSSPay?.INTERFACE_TYPE=="9052001" || this.payTypeSSPay?.INTERFACE_TYPE=="9056001"){
                timeout=45*1000;
            }
            console.log("请求 Bestech.CloudPos.SnackPayPreview",param);
            return this.$httpAES.requestConfig({
                timeout:timeout
            }).post("Bestech.CloudPos.SnackPayPreview", param).then(d=>{
                console.log("返回 Bestech.CloudPos.SnackPayPreview",d);
                return d;
            });
        },
        /**支付提交接口 */
        PaySubmit(data){
            let param={
                //User_ID:this.userInfo?.User_ID, //登陆用户ID
                Eat_AutoID: data?.Eat_AutoID,//结账单ID
                Member_Type:data?.Member_Type,  //会员类型
                Biz_ID:data?.Biz_ID, //业务交易流
                MantissaAdjustMoney:data?.MantissaAdjustMoney,//尾数调整金额
                Verify_Code:'', //验证码
                //Operator_Name:this.userInfo?.Login_Name, //操作员
                Timestamps:data?.Timestamps.toString(),
                Payments:data?.Payments
            }
            console.log('支付提交:',param)
            return this.$httpAES.post("Bestech.CloudPos.SnackPaySubmit", param).then((d)=>{
                console.log('支付提交返回:',d)
                return d;
            });
        },
        /**查询支付结果 */
        paySelect(data){
            let param={
                User_ID:this.userInfo?.User_ID,  //用户id
                Eat_AutoID:this.EatAutoID, //结账单ID
                Operator_Name:this.userInfo?.Login_Name, //操作员
                Operate_EquipmentID:this.userInfo?.Site_Serial, //设备id
                Pos_StationName:this.userInfo?.Site_Name, //站点名称
                Timestamps:this.Timestamps, //账单时间戳
            }
            Object.assign(param,data);
            if(this.EatAutoID==''){
                this.$message.error('没有需要查询的支付结果');
                return
            }
            console.log("请求 Bestech.CloudPos.RequeryThePaymentResult",param);
            return this.$httpAES.post("Bestech.CloudPos.RequeryThePaymentResult", param).then(d=>{
                console.log("返回 Bestech.CloudPos.RequeryThePaymentResult",d);
                return d;
            });
        },
    },
    unmounted(){
        this.$webBrowser.off("openSFAi");
        if(this._time){
            clearTimeout(this._time);
        }
        if(this._statusTime){
            clearTimeout(this._statusTime);
        }
        if(this._sfTime){
            clearTimeout(this._sfTime);
        }
    }
}
</script>

<style lang="scss" >
@import './sfAIFastFoodDetail.scss';
</style>